/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { EnvironmentType } from "~/generated/graphql";

export const types = [
  EnvironmentType.Production,
  EnvironmentType.Staging,
  EnvironmentType.Development,
  EnvironmentType.Other,
];

export type RouteParams = {
  application: string;
  environment?: string;
};
